/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  HideMcpServerRequestBody,
  HideMcpServerRequestBody$Outbound,
  HideMcpServerRequestBody$outboundSchema,
} from "../components/hidemcpserverrequestbody.js";

export type HideMcpServerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type HideMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  hideMcpServerRequestBody: HideMcpServerRequestBody;
};

/** @internal */
export type HideMcpServerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const HideMcpServerSecurity$outboundSchema: z.ZodMiniType<
  HideMcpServerSecurity$Outbound,
  HideMcpServerSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function hideMcpServerSecurityToJSON(
  hideMcpServerSecurity: HideMcpServerSecurity,
): string {
  return JSON.stringify(
    HideMcpServerSecurity$outboundSchema.parse(hideMcpServerSecurity),
  );
}

/** @internal */
export type HideMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  HideMcpServerRequestBody: HideMcpServerRequestBody$Outbound;
};

/** @internal */
export const HideMcpServerRequest$outboundSchema: z.ZodMiniType<
  HideMcpServerRequest$Outbound,
  HideMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    hideMcpServerRequestBody: HideMcpServerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      hideMcpServerRequestBody: "HideMcpServerRequestBody",
    });
  }),
);

export function hideMcpServerRequestToJSON(
  hideMcpServerRequest: HideMcpServerRequest,
): string {
  return JSON.stringify(
    HideMcpServerRequest$outboundSchema.parse(hideMcpServerRequest),
  );
}
